import { getBrowserName, sanitizeUrl } from "./common";
import { getTimeZone } from "./date";

export const initializeInputsWithUrlParameters = (inputs) => {
	const urlParameters = new URLSearchParams(
		window.location.search.replace("inquiry=", "subject=")
	);
	urlParameters.forEach((parameterValue, parameterName) => {
		if (parameterValue && inputs[parameterName]?.name) {
			const input = inputs[parameterName];
			if (input.type === "select") {
				if (
					input.options?.some(
						(option) => option?.value?.toString() === parameterValue.toString()
					)
				) {
					inputs[parameterName].focus = true;
					inputs[parameterName].initialValue = parameterValue;
				}
			} else {
				inputs[parameterName].initialValue = parameterValue;
			}
		}
	});
	return inputs;
};

const getText = (input, value) => {
	const inputType = input?.type;
	let text;
	switch (inputType) {
		case "select":
			const selectedOption = input?.options?.find(
				(option) => option.value?.toString() === value?.toString()
			);
			if (selectedOption?.value) {
				text = selectedOption?.text;
			}
			break;
		case "checkbox":
			const { checked, unchecked } = input?.text || {};
			text = value ? checked : unchecked;
			break;
		default:
			text = value;
	}
	return text;
};

const buildEmailLabels = (field, value) => {
	return {
		name: field.name,
		label: field.notTranslatableLabel,
		text: getText(field, value),
	};
};

const getAdditionalFieldsValues = (additionalFields, formInputs) => {
	const transformedAdditionalFields = [];
	for (const fieldName in additionalFields) {
		if (
			Array.isArray(additionalFields[fieldName].fields) &&
			additionalFields[fieldName].fields.length
		) {
			additionalFields[fieldName].fields.forEach((field) => {
				if (Array.isArray(field.formFields) && field.formFields.length) {
					field.formFields.forEach((groupField) => {
						if (groupField.type === "file") return;
						transformedAdditionalFields.push(
							buildEmailLabels(groupField, formInputs[groupField?.name])
						);
					});
				} else {
					if (field.type === "file") return;
					transformedAdditionalFields.push(
						buildEmailLabels(field, formInputs[field?.name])
					);
				}
			});
		}
	}
	return transformedAdditionalFields;
};

const getExpandedFormInputs = (inputs, formInputs) => {
	const expandedFormInputs = {};
	for (const inputName in formInputs) {
		if (
			inputName === "files" ||
			inputs[inputName]?.type === "file" ||
			!inputs[inputName]?.name
		) {
			continue;
		}
		expandedFormInputs[inputName] = {
			label: inputs[inputName]?.notTranslatableLabel,
			pattern: inputs[inputName]?.pattern,
			required: inputs[inputName]?.required,
			text: getText(inputs[inputName], formInputs[inputName]),
		};
		if (["select", "nestedSelect"].includes(inputs[inputName]?.type)) {
			expandedFormInputs[inputName].value = formInputs[inputName];
		}
	}
	return expandedFormInputs;
};

export const getEmailServiceBody = (
	inputs,
	formInputs,
	additionalFields,
	emailData,
	swid
) => {
	return {
		...getExpandedFormInputs(inputs, formInputs),
		devToEmailAddress:
			window.sessionStorage.getItem("devEmailSendTo") ||
			emailData.devEmailSendTo,
		usernameLabel: emailData.usernameLabel,
		defaults: {
			fields: emailData?.defaults,
			subject: emailData?.subject,
		},
		fromEmailAddressLabel: emailData.fromEmailAddressLabel,
		emailSubject: emailData?.emailSubject,
		formSubmittedLanguage: emailData?.formSubmittedLanguage,
		userAgent: {
			label: emailData.userAgentLabel,
			text: window.navigator.userAgent,
		},
		requestDetails: {
			label: emailData.requestDetails,
			text: emailData.emailComment,
		},
		selectedInquiries: {
			label: emailData.selectedInquiries,
		},
		requestTitle: {
			label: emailData.requestTitle,
		},
		ref: emailData.ref,
		zendeskRef: {
			parent: emailData.parentRef,
			description: emailData.descriptionRef,
		},
		source:{
			text: emailData?.source
		},
		requestDateTimezone: emailData.requestDateTimezone,
		browserName: { value: getBrowserName() },
		swid: { value: swid },
		timeZone: { value: getTimeZone() },
		dynamicFields: getAdditionalFieldsValues(additionalFields, formInputs),
		type: emailData.type,
		extractEmailAddressFrom: emailData.extractEmailAddressFrom,
		route: sanitizeUrl(window.location.pathname),
	};
};
